module.exports = __webpack_public_path__ + "asset/image/arrowDown-e603.svg";